import { createSelector } from 'reselect'
import orderBy from 'lodash/orderBy'
import {
  getGroups,
  getGroupsArray
} from '../../../../stores/groups/groups.selectors'

const getData = (state, selector) => {
  const data = state.GroupsComponent ? state.GroupsComponent : state
  return !data ? null : selector(data)
}

const getSelectedGroups = state => getData(state, data => data.selectedGroups)

const isShowingSelected = state => getData(state, data => data.showSelected)

const getSelectedGroupsIdsArray = createSelector(
  [getSelectedGroups],
  groups => {
    const groupsIdArray = []
    Object.keys(groups).forEach(id => groups[id] && groupsIdArray.push(id))
    return groupsIdArray
  }
)

const getSelectedGroupsArray = createSelector(
  [getGroups, getSelectedGroupsIdsArray],
  (groups, selectedGroupsArray) => selectedGroupsArray.map(id => groups[id])
)

const isGroupSelected = (state, id) => getSelectedGroups(state)[id] || false

const getSortBy = state => getData(state, data => data.sortBy)

const getSelectedGroupsLength = createSelector(
  [getSelectedGroups],
  selectedGroups => Object.keys(selectedGroups).length
)

const isEveryoneSelected = createSelector(
  [getSelectedGroupsLength, getGroupsArray],
  (selectedGroupsLength, groups) =>
    selectedGroupsLength === groups.length ? true : false
)

const getGroupsConditionally = createSelector(
  [getGroupsArray, isShowingSelected, getSelectedGroupsArray],
  (groups, isShowingSelected, selectedGroups) =>
    isShowingSelected ? selectedGroups : groups
)

const getSortedGroups = createSelector(
  [getSortBy, getGroupsConditionally],
  (sort, groupsArray) => {
    if (!sort.key) return groupsArray
    const propsMap = {
      title: group => group.title,
      access: group => group.visibility,
      students_count: group => group.number_of_students
    }
    return orderBy(groupsArray, propsMap[sort.key], sort.direction)
  }
)

export {
  getSelectedGroups,
  getSelectedGroupsIdsArray,
  getSelectedGroupsLength,
  getSortedGroups,
  getSortBy,
  isEveryoneSelected,
  isGroupSelected,
  isShowingSelected
}
